define('redactor/src/limiter.module',['require','exports','module','jquery','./redactor.patched'],function(require, exports, module) {
	var $ = require('jquery');
					require('./redactor.patched');

	$.Redactor.prototype.limiter = function()
	{
		return {
			init: function()
			{
				if (!this.opts.limiter)
				{
					return;
				}

				this.core.editor().on('keydown.redactor-plugin-limiter', $.proxy(function(e)
				{
					var key = e.which;
					var ctrl = e.ctrlKey || e.metaKey;

					if (key === this.keyCode.BACKSPACE
						|| key          === this.keyCode.DELETE
						|| key          === this.keyCode.ESC
						|| key          === this.keyCode.SHIFT
						|| key          === this.keyCode.LEFT
						|| key          === this.keyCode.LEFT_WIN
						|| key          === this.keyCode.RIGHT
						|| (ctrl && key === 65)
						|| (ctrl && key === 82)
						|| (ctrl && key === 116)
					)
					{
						return;
					}

					var text = this.core.editor().text();
					text = text.replace(/\u200B/g, '');

					var count = text.length;
					if (count >= this.opts.limiter)
					{
						return false;
					}


				}, this));

			}
		};
	};
  module.exports = $.Redactor.prototype.limiter;
});

